// From https://material-ui.com/customization/color/
// export const PILL0_PINK = '#f48fb1'
export const PILL0_PINK = '#d96d9a'